import React, { useEffect, useState } from "react";
// import ms1 from '../../assets/marshall/ms1.png';
import signaturesound from "../../assets/marshall/features/signaturesound.png";
import ip6 from "../../assets/marshall/features/ip6.png";
import playtime from "../../assets/marshall/features/playtime.png";
import stackmode from "../../assets/marshall/features/stackmode.png";
import microphone from "../../assets/marshall/features/microphone.png";
import recycled from "../../assets/marshall/features/recycle.png";
import Nav from "../Nav/Nav";
import ScrollTop from "../Scrolltop"; // Import the ScrollToTop component
import { useParams } from "react-router-dom";

import {
  Facebook,
  Instagram,
  // Share2,
  //  Link as LinkIcon
} from "lucide-react";

// redux
import { useSelector } from "react-redux";

function MarshallDetails() {
  // redux
  const speakers = useSelector((state) => state.products.portableSpeakers);
  const headphones = useSelector((state) => state.products.headphones);

  const { type, id } = useParams();

  const [productDetails, setProductDetails] = useState("");

  useEffect(() => {
    if (type === "speakers") {
      setProductDetails(speakers.find((product) => product.id === Number(id)));
    } else if (type === "headphones") {
      setProductDetails(
        headphones.find((product) => product.id === Number(id))
      );
    }
  }, [type, id, headphones, speakers]);

  // social

  function facebookProfile() {
    window.open(`https://www.facebook.com/galaxcitygadgets/`, "_blank");
  }
  function instagramProfile() {
    window.open(`https://www.instagram.com/galaxcitygadgets.store?igsh=MjVkYmRkb3RidWQ5&utm_source=qr/`, '_blank');
  }
  function whatsappChat() {
    const title = `${productDetails.productName}`;
    const productUrl = window.location.href;

    // Encode message text
    const message = `Hey I want to buy this item:\n\nProduct name - ${title}\n${productUrl}`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/7005665616?text=${encodedMessage}`, "_blank");
  }
  return (
    <>
      <ScrollTop />
      <Nav theme="dark" />
      <div class="detail-container">
        {/* Left Container */}
        <div class="detail-left-section">
          <div className="detail-img-container">
            <img
              src={productDetails.picture}
              alt="Marshall Willen"
              class="detail-image"
            />
          </div>
        </div>
        {/* Right Container */}
        <div class="detail-right-section">
          <div className="d-flex justify-content-between align-items-center">
            <div class="detail-title">{productDetails.productName}</div>
            <div className="button-row pb-2">
              <button
                className="apl-btn buy-button"
                onClick={() => whatsappChat()}
              >
                Order via WhatsApp
              </button>
            </div>
          </div>
          <h2 className="detail-punch-line">{productDetails.punchLine}E</h2>
          <p class="detail-subtitle">{productDetails.playtime}</p>
          <div className="hr-line"></div>
          <p class="detail-description">{productDetails.productDescription}</p>
          <h2 class="detail-price">MRP: {productDetails.price}</h2>
          <div class="features-grid">
            <div class="feature-box">
              <div className="detail-icon">
                <img src={signaturesound} alt="signaturesound" />
              </div>

              <p>
                MARSHALL
                <br />
                SIGNATURE SOUND
              </p>
            </div>
            <div class="feature-box">
              <div className="detail-icon">
                <img src={ip6} alt="ip6" />
              </div>
              <p>
                IP67 DUST- &<br />
                WATER-RESISTANT
              </p>
            </div>
            <div class="feature-box">
              <div className="detail-icon">
                <img src={playtime} alt="playtime" />
              </div>
              <p>
                15+ HOURS OF
                <br />
                PLAYTIME
              </p>
            </div>
            <div class="feature-box">
              <div className="detail-icon">
                <img src={stackmode} alt="stackmode" />
              </div>
              <p>STACK MODE</p>
            </div>
            <div class="feature-box">
              <div className="detail-icon">
                <img src={microphone} alt="microphone" />
              </div>
              <p>
                BUILT-IN
                <br />
                MICROPHONE
              </p>
            </div>
            <div class="feature-box">
              <div className="detail-icon">
                <img src={recycled} alt="recycled" />
              </div>
              <p>
                60% RECYCLED
                <br />
                PLASTIC*
              </p>
            </div>
          </div>

          <div class="detail-colors">
            COLOURS:{" "}
            {/* {productDetails.colors.map((color) => {
              return <span>{color}</span>;
            })} */}
            <span>BLACK</span> ⚫ <span>GREY</span> ⚪
          </div>

          {/* social */}

          <div className="muvtechDetails-social">
            <Facebook
              onClick={() => facebookProfile()}
              className="social-icon facebook muvsocial"
            />
            <Instagram
              onClick={() => instagramProfile()}
              className="social-icon instagram muvsocial"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default MarshallDetails;
